import { toast } from "react-toastify";

 const fallbackCopyText = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed"; 
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        toast.success("ID copied to clipboard!", {
          autoClose: 2000,
          pauseOnHover: false,
        });
      } else {
        toast.error("Failed to copy ID.");
      }
    } catch (err) {
      toast.error("Failed to copy ID.");
    }
    document.body.removeChild(textArea);
  };
  export default fallbackCopyText